<template>
  <div class>
    <Toast />

    <div class="content-card">
      <h5>
        <b>Buat Retur Supplier</b>
      </h5>
      <div class="p-grid p-fluid p-mb-3">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Supplier</label>
          <div>
            <!-- <AutoComplete
                placeholder="Warehouse"
                :dropdown="true"
                :multiple="false"
                v-model="selectedWarehouse"
                :suggestions="autoFiltered"
                @complete="searchWarehouse($event)"
                field="name"
                @input="isError.warehouse_id = false"
              >
                <template #item="slotProps">
                  <div>{{ slotProps.item.name }}</div>
                  <div style="font-style: italic; font-size: 12px">
                    {{ slotProps.item.code }}
                  </div>
                </template>
              </AutoComplete> -->
            <AutoComplete
              placeholder="Supplier"
              :dropdown="true"
              v-model="selected_supplier"
              :suggestions="autoFilteredValue"
              @complete="searchSupplier($event)"
              field="code"
            >
              <template #item="slotProps">
                <div>{{ slotProps.item.name }}</div>
                <div style="font-style: italic; font-size: 12px">
                  {{ slotProps.item.code }}
                </div>
              </template>
            </AutoComplete>
          </div>
          <small class="p-error" v-if="isError.warehouse_id">{{
            error_msg.warehouse_id
          }}</small>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Tanggal Bon</label>
          <div>
            <InputText
              type="date"
              :readonly="true"
              :disabled="true"
              v-model="today"
            />
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4">
          <label>Tanggal Bon Pembelian Barang</label>
          <div>
            <InputText
              type="date"
              :readonly="false"
              :disabled="false"
              v-model="purchase_date"
            />
          </div>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>Stok</th>
                <th>Harga (Rp)</th>
                <th>Jumlah</th>
                <th>Total Harga (Rp)</th>
                <th>Hapus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k">
                <td>
                  <AutoComplete
                    placeholder="Code"
                    :dropdown="true"
                    :multiple="false"
                    v-model="an_item.selected_item"
                    :suggestions="autoFiltered"
                    @complete="getItems"
                    @input="chooseDropdownChanges(k)"
                    field="code"
                    :disabled="!selected_supplier"
                  >
                    <template #item="slotProps">
                      <div>{{ slotProps.item.name }}</div>
                      <div style="font-style: italic; font-size: 12px">
                        {{ slotProps.item.code }}
                      </div>
                    </template>
                  </AutoComplete>
                  <small class="p-error" v-if="isError.items[k].id">{{
                    error_msg.items[k].id
                  }}</small>
                </td>
                <td>
                  <InputText
                    :disabled="true"
                    v-model="an_item.name"
                    placeholder="Name"
                  />
                </td>
                <td>
                  <InputNumber
                    :disabled="true"
                    v-model="an_item.stock"
                    placeholder="0"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.cap_price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <InputText
                    type="number"
                    v-model="an_item.qty"
                    placeholder="0"
                    @keyup.prevent="qtyChanges(k)"
                    @change="qtyChanges(k)"
                  />
                  <small class="p-error" v-if="isError.items[k].qty">{{
                    error_msg.items[k].qty
                  }}</small>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.total"
                    :disabled="true"
                  />
                </td>
                <td class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label>Total</label>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_qty"
                    :disabled="true"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <Button
                    icon="pi pi-plus"
                    label="Tambah"
                    class="p-mr-2"
                    @click="addNewRow()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="p-grid p-justify-center">
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="saveChanges"
            :disabled="loading.createButton"
          >
            Buat
            <span v-if="loading.createButton">
              <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      today: new Date().toISOString().split('T')[0],
      purchase_date: new Date().toISOString().split('T')[0],
      bon: null,
      autoFiltered: [],
      suppliers: [],
      filtered_suppliers: [],
      selected_supplier: { id: '', code: '', name: '' },
      autoFilteredValue: [],
      items_checked: false,
      isError: {
        warehouse_id: false,
        doc_number: false,
        doc_date: false,
        items: [{ id: false, qty: false }]
      },
      error_msg: {
        warehouse_id: '',
        doc_number: '',
        doc_date: '',
        items: [{ id: '', qty: '' }]
      },
      items: [],
      total_price: 0,
      total_qty: 0,
      items_temp: [
        {
          selected_item: '',
          name: '',
          stock: 0,
          qty: null,
          cap_price: 0,
          total: 0,
          description: ''
        }
      ],
      inputData: {
        supplier_id: 0,
        doc_date: '',
        purchase_doc_date: '',
        amount: 0,
        items: [
          {
            id: 0,
            qty: 0
          }
        ]
        // type: 'RETURN'
      },
      loading: {
        filter: false,
        createButton: false
      },
      limit: 10,
      allSuppliers: []
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    // this.getItems()
    // this.searchSupplier()
    this.getListSuppliers(null, true)
  },
  methods: {
    async getListSuppliers(event, useLimit = true) {
      let sup_code = this.selected_supplier.code
        ? this.selected_supplier.code
        : ''

      let sup_name = ''

      if (this.selected_supplier) {
        if (this.selected_supplier.name) {
          sup_name = this.selected_supplier.name
        } else if (!(this.selected_supplier instanceof Object)) {
          sup_name = this.selected_supplier
        } else {
          sup_name = ''
        }
      }

      this.loading.filter = true
      try {
        const limitParam = useLimit ? `&limit=${this.limit}` : ''
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/suppliers?code=${sup_code}&name=${sup_name}${limitParam}`
        )
        this.loading.filter = false
        if (response.status === 200) {
          if (useLimit) {
            this.suppliers = response.data.data.suppliers
          } else {
            this.allSuppliers = response.data.data.suppliers
          }
          this.total_records = response.data.data.total
        }
      } catch (error) {
        this.loading.filter = false
        console.error('Error fetching suppliers:', error)
      }
    },

    async searchSupplier(event) {
      if (!event.query) {
        this.autoFilteredValue = this.suppliers
        return
      }

      if (this.allSuppliers.length === 0) {
        await this.getListSuppliers(null, false)
      }
      this.autoFilteredValue = this.allSuppliers.filter(item => {
        return (
          item.code.toLowerCase().includes(event.query.toLowerCase()) ||
          item.name.toLowerCase().includes(event.query.toLowerCase())
        )
      })
    },

    getItems(event) {
      let code
      if (event != null && event.query != null) {
        code = event.query
      }
      let sup_id = this.selected_supplier.id

      this.$http
        .get(
          // `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&limit=5`
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&supplier_id=${sup_id}&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            this.bon = response.data.data.doc_number
            this.autoFiltered = this.filterItems(event)
          }
        })
    },

    filterItems(event) {
      let query
      if (event != null && event.query != null) {
        query = event.query
      }
      const lowerCaseQuery = query.toLowerCase()
      return this.items.filter(item => {
        return (
          item.name.toLowerCase().indexOf(lowerCaseQuery) === 0 ||
          item.code.toLowerCase().indexOf(lowerCaseQuery) === 0
        )
      })
    },

    chooseDropdownChanges(index) {
      for (const item of this.inputData.items) {
        // check if item is searchItems
        if (item.id === this.items_temp[index].selected_item.id) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Barang sudah dipilih',
            life: 3000
          })
          // clear selected item
          this.items_temp[index].selected_item = ''
          this.items_temp[index].name = ''
          this.items_temp[index].stock = 0
          this.items_temp[index].cap_price = 0
          this.inputData.items[index].id = 0
          this.inputData.items[index].qty = 0
          this.items_temp[index].qty = null
          return
        }
      }
      if (this.items_temp[index].selected_item instanceof Object) {
        this.isError.items[index].id = false

        this.inputData.items[index].id = this.items_temp[index].selected_item.id
        this.items_temp[index].cap_price = parseFloat(
          this.items_temp[index].selected_item.cap_price
        )
        this.items_temp[index].name = this.items_temp[index].selected_item.name
        this.items_temp[index].stock =
          this.items_temp[index].selected_item.stock

        this.calculateLineTotal(index)
      }
    },

    qtyChanges(index) {
      this.isError.items[index].qty = false
      this.inputData.items[index].qty = parseInt(this.items_temp[index].qty)
      this.calculateLineTotal(index)
    },

    calculateLineTotal(index) {
      let qty = parseInt(this.items_temp[index].qty) || 0

      this.items_temp[index].total = qty * this.items_temp[index].cap_price
      this.calculateTotal()
    },

    calculateTotal() {
      this.total_price = this.items_temp.reduce(function (sum, item) {
        return sum + item.total
      }, 0)

      this.total_qty = this.items_temp.reduce(function (sum, item) {
        const qty = parseInt(item.qty) || 0 // Mengubah qty menjadi integer atau berikan nilai default 0 jika tidak valid
        return (sum += qty)
      }, 0)
    },

    saveChanges() {
      if (this.selected_supplier instanceof Object) {
        this.inputData.supplier_id = this.selected_supplier.id
      } else {
        this.isError.warehouse_id = true
        this.error_msg.warehouse_id = 'choose this input first'
      }

      this.inputData.amount = this.total_price
      this.inputData.doc_date = this.today
      this.inputData.purchase_doc_date = this.purchase_date

      for (let i = 0; i < this.inputData.items.length; i++) {
        if (
          !this.inputData.items[i].id <= 0 ||
          !this.inputData.items[i].id === '0'
        ) {
          this.items_checked = true
        } else {
          this.isError.items[i].id = true
          this.error_msg.items[i].id = 'select item first'
          this.items_checked = false
          break
        }

        if (this.inputData.items[i].qty <= this.items_temp[i].stock) {
          this.items_checked = true
        } else {
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'qty must > 0 and <= stock'
          this.items_checked = false
          break
        }

        if (this.inputData.items[i].qty <= this.items_temp[i].stock) {
          this.items_checked = true
        } else {
          this.loading.createButton = false
          this.$toast.add({
            severity: 'error',
            summary: 'Submit items failed',
            detail: 'Qty must be less than stock',
            life: 3000
          })
          return
        }

        if (!this.outlet_id)
          if (
            !this.inputData.items[i].qty <= 0 ||
            !this.inputData.items[i].qty === '0' ||
            !this.inputData.items[i].qty === ''
          ) {
            this.items_checked = true
          } else {
            this.loading.createButton = false
            this.isError.items[i].qty = true
            this.error_msg.items[i].qty = 'qty must > 0 and <= stock'
            this.items_checked = false
            break
          }
        //   this.inputData.items[i].description = this.items_temp[i].description
      }
      if (
        this.total_price >= 0 &&
        this.total_qty >= 0 &&
        this.inputData.supplier_id != 0 &&
        this.inputData.doc_date != '' &&
        this.inputData.purchase_doc_date != '' &&
        this.items_checked
      ) {
        this.loading.createButton = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/supplier/return`,
            this.inputData
          )
          .then(response => {
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Submit items Success',
                detail: 'Congrats, those items has been submitted',
                life: 3000
              })
              this.total_price = 0
              this.total_qty = 0
              this.items_temp = [
                {
                  qty: 0,
                  cap_price: 0,
                  total: 0
                }
              ]
              this.selected_supplier = null
              this.inputData = {
                supplier_id: 0,
                amount: 0,
                // doc_number: '',
                purchase_doc_date: '',
                doc_date: '',
                items: [
                  {
                    id: 0,
                    qty: 0
                  }
                ]
              }
              setTimeout(() => {
                this.getListWarehouse()
                this.getItems()
              }, 500)
              this.loading.createButton = false
            } else {
              this.loading.createButton = false
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal Mengirim',
                detail: 'Tanggal Bon Pembelian Tidak Valid',
                life: 3000
              })
            }
          })
      }
    },

    deleteRow(index, an_item) {
      let idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.inputData.items.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
      }
      this.calculateTotal()
    },
    addNewRow() {
      this.items_temp.push({
        // code: '',
        name: '',
        cap_price: 0,
        qty: null,
        total: 0
      })
      this.inputData.items.push({
        id: 0,
        qty: null
      })
      this.isError.items.push({ id: false, qty: false })
      this.error_msg.items.push({ id: '', qty: '' })
      this.calculateTotal()
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
